import React from 'react';
import '../App.css';
import TextField from 'material-ui/TextField';

import ContraLogo from '../Graphics/contraline_logo.png';

export default class InterestForm extends React.Component {
  render() {
    return (
      <div className="panel">
        <div className="panel-header">
          <p>
            To receive updates about Contraline, enter your name and email
            below.{' '}
          </p>
        </div>
        <div className="panel-body">
          <input
            className="input"
            placeholder="First Name"
            value={this.props.state.first_name}
            onChange={e => this.props.onChange('first_name', e.target.value)}
          />
          <input
            className="input"
            placeholder="Last Name"
            value={this.props.state.last_name}
            onChange={e => this.props.onChange('last_name', e.target.value)}
          />
          <input
            className="input"
            placeholder="Email Address"
            value={this.props.state.email}
            onChange={e => this.props.onChange('email', e.target.value)}
          />
          <div className="checkbox-group">
            <p className="checkbox-label">Which product(s) are you interested in? (select all that apply)</p>
            <label className="checkbox-option">
              <input
                type="checkbox"
                checked={this.props.state.interest_adam}
                onChange={e => this.props.onChange('interest_adam', e.target.checked)}
              />
              ADAM <span className="checkbox-desc">(long-lasting implant)</span>
            </label>
            <label className="checkbox-option">
              <input
                type="checkbox"
                checked={this.props.state.interest_nest}
                onChange={e => this.props.onChange('interest_nest', e.target.checked)}
              />
              NES/T <span className="checkbox-desc">(daily topical gel)</span>
            </label>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InterestForm.js